"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const static_colors_1 = __importDefault(require("./static-colors"));
const output = {
    name: 'global',
    colors: static_colors_1.default,
};
exports.default = output;
//# sourceMappingURL=tokens.js.map